export type ApiErrorBody = {
  success?: boolean;
  data?: unknown;
  code?: string | number;
  message?: string;
  errorMessage?: string;
  traceId?: string;
  displayMessage?: string;
};

const REQUEST_ERROR_HANDLED_KEY = '__tradeAutoRequestErrorHandled';

type RequestErrorHandledFlag = {
  [REQUEST_ERROR_HANDLED_KEY]?: boolean;
};

const toText = (value: unknown) => {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).trim();
};

export const getApiErrorRawMessage = (errorInfo?: ApiErrorBody, fallback = '请求失败') => {
  return toText(errorInfo?.errorMessage) || toText(errorInfo?.message) || fallback;
};

export const formatApiErrorMessage = (errorInfo?: ApiErrorBody, fallback = '请求失败') => {
  const displayMessage = toText(errorInfo?.displayMessage);
  if (displayMessage) {
    return displayMessage;
  }

  const messageText = getApiErrorRawMessage(errorInfo, fallback);
  const code = toText(errorInfo?.code);
  const traceId = toText(errorInfo?.traceId);

  return `${messageText}${code ? `(${code})` : ''}${traceId ? `\ntraceId: ${traceId}` : ''}`;
};

export const isApiErrorBody = (data: unknown): data is ApiErrorBody => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const body = data as ApiErrorBody;
  return (
    body.success === false ||
    Boolean(toText(body.code)) ||
    Boolean(toText(body.message)) ||
    Boolean(toText(body.errorMessage)) ||
    Boolean(toText(body.traceId))
  );
};

export const markRequestErrorHandled = (error: unknown) => {
  if (error && typeof error === 'object') {
    (error as RequestErrorHandledFlag)[REQUEST_ERROR_HANDLED_KEY] = true;
  }
};

export const isRequestErrorHandled = (error: unknown) => {
  return Boolean(
    error &&
      typeof error === 'object' &&
      (error as RequestErrorHandledFlag)[REQUEST_ERROR_HANDLED_KEY],
  );
};
